import { render, staticRenderFns } from "./customColumn.vue?vue&type=template&id=196271ac"
import script from "./customColumn.vue?vue&type=script&lang=js"
export * from "./customColumn.vue?vue&type=script&lang=js"
import style0 from "./customColumn.vue?vue&type=style&index=0&id=196271ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports